import React from "react";
import { Spinner, Badge } from "reactstrap";
import { useTable, useSortBy } from "react-table";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import useSponsorLogoPlacementAnalysis from "../query/hooks/useSponsorLogoPlacementAnalysis";

const LogoPlacementTable = ({ sponsorObjectId }) => {
  const { t } = useTranslation();
  const { data, isFetching } = useSponsorLogoPlacementAnalysis(sponsorObjectId);

  const columns = useMemo(() => data.headers, [data]);
  const dataRows = useMemo(() => data.rows, [data]);
  const summary = useMemo(() => data.summary, [data]);

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data: dataRows,
      },
      useSortBy
    );

  return (
    <>
      {isFetching && <Spinner color="primary" />}
      
      {/* Main Table */}
      <div className="table-responsive">
        <table
          className="table table-hover table-centered table-nowrap mb-0 text-white"
          {...getTableProps()}
        >
          <thead>
            {headerGroups.map((headerGroup, index) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, columnIndex) => (
                  <th
                    width={
                      columnIndex === 0 ? "25%" : 
                      columnIndex === 1 ? "20%" : 
                      "15%"
                    }
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    className="cursor-pointer"
                  >
                    {column.render("Header")}
                    <span>
                      {column.isSorted ? (
                        column.isSortedDesc ? (
                          <span className="mdi mdi-chevron-down ms-1"></span>
                        ) : (
                          <span className="mdi mdi-chevron-up ms-1"></span>
                        )
                      ) : (
                        <span className="mdi mdi-unfold-more-horizontal ms-1 text-muted"></span>
                      )}
                    </span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row, i) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => {
                      return (
                        <td {...cell.getCellProps()}>
                          {cell.render("Cell")}
                        </td>
                      );
                    })}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={columns.length} className="text-center py-4">
                  <div className="text-muted">
                    <i className="mdi mdi-information-outline me-2"></i>
                    {t("No logo placement data available for the selected period")}
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default LogoPlacementTable;